import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { ClientInput } from "../inputs/ClientInput";
import { clientEntriesSelector } from "../../store/selectors/clientEntries";
import { interactiveClientSelector } from "../../store/selectors/clientSettings";
import { operationsMethods, CalculationValue, formatValue } from "../../lib/fields/Calculation/helpers";

// TODO: This might be better as a TableCalculations component where we
// change the operation based on the rules. The overall approach _should_
// be the same...
export const SumPreview = ({
  label,
  id,
  update,
  mask = 0,
  style = 0,
  summary_entry,
  errors,
  onBlur
}) => {
  const {
    guid: sumEntryGuid
  } = summary_entry || {};
  const clientEntries = useSelector(clientEntriesSelector);
  const interactiveClient = useSelector(interactiveClientSelector);
  const entryValues = clientEntries.filter(({
    parentGuid
  }) => {
    return parentGuid === sumEntryGuid;
  }).map(entry => {
    // TODO: Don't totally love this, but it handles different formats
    // in a safe way.
    return CalculationValue(entry).value;
  });
  const operation = operationsMethods['add'];
  const calculation = interactiveClient ? entryValues.reduce(operation, 0) : 0;
  const formattedValue = formatValue(calculation, style, mask);
  useEffect(() => {
    update(formattedValue);
  }, [calculation, mask]);
  const numberProps = {
    value: formattedValue,
    readOnly: true,
    disabled: true,
    label: label,
    id,
    errors,
    errorText: errors
  };
  return <ClientInput {...numberProps} />;
};